import Vue from 'vue'
import Router from 'vue-router'
import mainView from '@/components/main'
import hipspanic from '@/components/hispanic'
import ourwork from '@/components/ourwork'
import work from '@/components/work'
import mobile from '@/components/mobile'
import projects from '@/components/projects'
import project from '@/components/project'
import client from '@/components/client'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
        return {selector: to.hash}
    } else {
        return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Main',
      component: mainView
    },
    {
      path: '/Hipspanic',
      name: 'Hipspanic',
      component: hipspanic
    },
    {
      path: '/OurWork',
      name: 'OurWork',
      component: ourwork
    },
    {
      path: '/work/:work',
      name: 'Work',
      component: ourwork
    },
    {
      path: '/mobile',
      name: 'Mobile',
      component: mobile
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: projects
    },
    {
      path: '/dashboard/:project',
      name: 'Dashboard',
      component: projects
    },
    {
      path: '/project/:project',
      name: 'Project',
      component: project
    },
    {
      path: '/client/:project',
      name: 'Client',
      component: client
    },
    {
      path: '*',
      name: 'default',
      component: mainView
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js